
import XDialog from 'vux/src/components/x-dialog/index.vue'
import TransferDom from 'vux/src/directives/transfer-dom/index.js'

import { Swipe, SwipeItem, Popup, Dialog } from 'vant'
import failimg from '@/assets/lalisai/fail.jpg'
import card from './components/card.vue'
import config from '@/config'
import { operateCredit } from '@/api/user'
import { getExam, getview, save } from '@/api/jfhl.js'
import {
personRank,
addTaskOne,
personBasic,
firstTaskPanduan,
firstJoin,
firstTaskGet,
firstAddressGet,
addTaskThird,
everyDayFirst,
endPanduan,
getExaminfo
} from '@/api/lalisai'
export default {
directives: {
TransferDom
},
components: { card, XDialog, [Swipe.name]: Swipe, [SwipeItem.name]: SwipeItem, [Popup.name]: Popup },
name: 'index',
props: {},
data () {
return {
failimg: failimg, // 个人排行榜默认头像
baseUrl: config.baseUrl,
iconimg: this.$store.state.user.iconimgpath, // 个人微信头像
title1: '答题拉力赛',
title2: '助力排行榜',
top: '组队参与PK >>',

addressPanduan: false, // 首次地址判断
firstTaskGet: false, // 首次任务积分领取
showfirst: false, // 判断首次弹窗
addressGet: false, // 首次地址积分领取
firstTask: '', // 每日答题次数
secondTask: '', // 周六挑战答题次数
thirdTask: '', // 邀请次数
personinfor: '', // 个人排行信息
ranklist: [], // 个人排行榜信息
showDialog: false, // 展示每周题目答题
partyId: '1', // 拉力赛活动id——写死
partyid1: '92204', // 每日答题活动id
partyid2: '92203', // 每周六答题活动id
paperInfoid: '', // 答题id
examList: '', // 题目列表
subjectid: [], // 题目id列表
useroption: [], // 单选题选项列表
multi: [],
teamid: '', // 队伍id
rightnum: 0, // 答对题目数
showerrlist: false, // 展示错题列表
errorList: [], // 错题列表
once: true, // 防止连点
isdata: true,
issataday: true,
everyDayFirst: false, // 是否领取 是：已领取 否：未领取
everyDaySecond: false,
everyDayThird: false,
everyWeekFirst: false,
everyWeekSecond: false,
everyWeekThird: false,
inviteFirst: false,
inviteSecond: false,
inviteThird: false,
everyDayFourth: false,
everyWeekFourth: false,
inviteFourth: false,
everyDayTask: 0, // 每日答题次数
everyWeekTask: 0, // 每周六答题次数
isdati: true, // 判断活动是否开始
showbutton: true,
showfillin: true,
daynum: '' 
}
},
computed: {
accountid () {
return this.$store.state.user.accountid
}
},
watch: {
showDialog: function () {
this.useroption = []
}
},
created () {
if (this.$route.query.obj) {
let temp = this.$route.query.obj.slice(0, this.$route.query.obj.length - 1)


if (temp != this.accountid) {
addTaskThird({
inviter: temp,
bInviter: this.accountid,
partyId: this.partyId
}).then(res => {
this.$router.push({ name: 'lalisaiIndex' })

})
} else {
Dialog.alert({
message: '自己不能邀请自己哦！'
}).then(() => {
this.$router.push({ name: 'lalisaiInvite' })
})
}
}
this.getpanduan()
},
mounted () {
this.addcredit()

},
methods: {
addcredit () {
operateCredit({
accountid: this.accountid,
rulecode: 'rule_009',
credit: 50,
owner_type: '7',
relationtype: 2,
relationid: 1,
terminaltype: 2
})
},
getexaminfor () {
getExaminfo({
paperInfoid: this.paperInfoid
}).then(data => {
this.isCurrentTime(data.obj.begindate, data.obj.enddate)
})
},
getpanduan () {
endPanduan({
partyId: this.partyId
}).then(res => {
if (res.obj) {
this.view()
} else {
this.showbutton = false
this.$vux.alert.show({
content: '活动已结束'
})
return false
}
})
},
todetail () {
this.$router.push({ name: 'lalisaiDetail' })
},
view () {
getview({
id: this.partyid1
}).then(data => {
this.paperInfoid = data.obj.paperid
this.isCurrentTime2(data.obj.signstartdate, data.obj.signenddate)
})
},

isCurrentTime2 (beginTime, endTime) {
var currentTime = new Date()
let begin = new Date(beginTime.replace(/\-/g, '/'))
let end = new Date(endTime.replace(/\-/g, '/'))
if (currentTime < begin) {
this.isdati = false
this.showbutton = false
this.showfillin = false
this.top = ''
this.$vux.alert.show({
content: '活动还未开始'
})
return false
}
if (currentTime >= end) {
this.isdati = false
this.showbutton = false
this.$vux.alert.show({
content: '活动已结束'
})
this.getinfor()
this.getrank()
return false
}
this.getexaminfor()
this.goin()
},

isCurrentTime (beginTime, endTime) {
var currentTime = new Date()
var begin = new Date(beginTime.substring(0, beginTime.length - 2).replace(/\-/g, '/'))
var end = new Date(endTime.substring(0, endTime.length - 2).replace(/\-/g, '/'))
console.log(currentTime.getDay())
if (currentTime < begin) {
this.isdati = false



return false
}
if (currentTime >= end) {
this.isdati = false
this.showbutton = false



return false
}
this.getExam()
},
goin () {
firstJoin({
accountid: this.accountid,
partyId: this.partyId
}).then(res => {
this.getinfor()
this.getrank()
})
},







change () {
console.log(this.useroption)
if (this.useroption.length < this.examList.length) {
this.$refs.swipe.next()
} else {
if (this.once) {
this.once = false
save({
paperInfoid: this.paperInfoid,
subjectid: this.subjectid.join(';'),
useroption: this.useroption.join(';'),
openid: this.accountid
}).then(data => {
this.once = false
if (data.obj.ISTRUE === 1) {
this.rightnum = this.examList.length
} else {
let wt = data.obj.ERRORLIST.length
this.rightnum = this.examList.length - wt
this.errorList = data.obj.ERRORLIST
}
this.$refs.swipe.next()
addTaskOne({
num: this.rightnum,
accountid: this.accountid,
partyId: this.partyId
}).then(res => {
this.getexaminfor()
this.getinfor()
this.getrank()
})
})
}
}
},
getExam () {
getExam({
paperInfoid: this.paperInfoid,
openid: this.accountid
}).then(data => {
if (data.success) {
this.daynum = data.obj.ANSWERNUM
if (data.obj.ANSWERNUM <= 0) {


setTimeout(() => {




}, 1000)
return false
}
this.examList = data.obj.SUBJECTLIST
data.obj.SUBJECTLIST.forEach(element => {
this.subjectid.push(element.SUBJECTID)
})
}
})
},
getinfor () {
personBasic({
accountid: this.accountid,
partyId: this.partyId
}).then(res => {

this.addressPanduan = res.obj.llsPersonBasicinfo.addressPanduan
this.firstTask = res.obj.llsPersonBasicinfo.firstTask
this.secondTask = res.obj.llsPersonBasicinfo.secondTask
this.thirdTask = res.obj.llsPersonBasicinfo.thirdTask
this.firstTaskGet = res.obj.llsPersonBasicinfo.firstTaskGet
this.addressGet = res.obj.llsPersonBasicinfo.addressGet
this.everyDayFirst = res.obj.llsPersonBasicinfo.everyDayFirst
this.everyDaySecond = res.obj.llsPersonBasicinfo.everyDaySecond
this.everyDayThird = res.obj.llsPersonBasicinfo.everyDayThird
this.everyDayFourth = res.obj.llsPersonBasicinfo.everyDayFourth
this.everyWeekFirst = res.obj.llsPersonBasicinfo.everyWeekFirst
this.everyWeekSecond = res.obj.llsPersonBasicinfo.everyWeekSecond
this.everyWeekThird = res.obj.llsPersonBasicinfo.everyWeekThird
this.everyWeekFourth = res.obj.llsPersonBasicinfo.everyWeekFourth
this.inviteFirst = res.obj.llsPersonBasicinfo.inviteFirst
this.inviteSecond = res.obj.llsPersonBasicinfo.inviteSecond
this.inviteThird = res.obj.llsPersonBasicinfo.inviteThird
this.inviteFourth = res.obj.llsPersonBasicinfo.inviteFourth
this.everyDayTask = res.obj.everyDayTask
this.everyWeekTask = res.obj.everyWeekTask
if (res.teamId != null) {
this.teamid = res.obj.llsPersonBasicinfo.teamId
}
if (!this.firstTaskGet) {
this.showfirst = true
}
})
},
getrank () {
personRank({
accountid: this.accountid,
partyId: this.partyId
}).then(res => {
this.personinfor = res.obj.personRank
this.ranklist = res.obj.personRankAll
})
},
linklist () {
this.$router.push({ name: 'lalisaiList', params: { partyid: this.partyid2 } })
},
invite () {
this.$router.push({ name: 'lalisaiInvite' })
},
fillin () {
this.$router.push({ name: 'lalisaiInfor' })
},
subject () {
endPanduan({
partyId: this.partyId
}).then(res => {
if (res.obj) {
this.showDialog = true
}
})
},
showerror () {
this.showDialog = false
this.showerrlist = true
},
getvalue1 () {
this.showfirst = false
if (!this.firstTaskGet) {
firstTaskGet({
accountid: this.accountid,
partyId: this.partyId
}).then(res => {
if (res.success) {
this.$vux.toast.text('恭喜您获得20助力值')
setTimeout(() => {
this.getinfor()
this.getrank()
}, 1000)
}
})
}
},
getvalue2 () {
if (this.addressPanduan) {
firstAddressGet({
accountid: this.accountid,
partyId: this.partyId
}).then(res => {
if (res.success) {
this.getinfor()
this.getrank()
}
})
}
},
getvalue3 (num, type, down, did) {
if (!down && did) {
everyDayFirst({
accountid: this.accountid,
partyId: this.partyId,
num: num,
type: type
}).then(res => {
if (res.success) {
this.getinfor()
this.getrank()
}
})
}
}
}
}
